module.exports = __webpack_public_path__ + "static/img/orgDown.f5e69a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/orgDown.png
// module id = M6BQ
// module chunks = 2